import { render, staticRenderFns } from "./AddNewProjet.vue?vue&type=template&id=2365689a&scoped=true&"
import script from "./AddNewProjet.vue?vue&type=script&lang=js&"
export * from "./AddNewProjet.vue?vue&type=script&lang=js&"
import style0 from "./AddNewProjet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddNewProjet.vue?vue&type=style&index=1&id=2365689a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365689a",
  null
  
)

export default component.exports